import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderCard from './OrderCard';
import './OrderQueue.css';

const OrderQueue = ({
  orders,
  viewMode,
  newOrderIds,
  onStartItem,
  onCompleteItem,
  onResetItem,
  onBumpOrder
}) => {
  const { t } = useTranslation();
  const pending = orders.filter((o) => o.status === 'pending');
  const preparing = orders.filter((o) => o.status === 'preparing');
  const ready = orders.filter((o) => o.status === 'ready');

  const renderCard = (order) => (
    <OrderCard
      key={order.id}
      order={order}
      isNew={newOrderIds ? newOrderIds.has(order.id) : false}
      onStartItem={onStartItem}
      onCompleteItem={onCompleteItem}
      onResetItem={onResetItem}
      onBumpOrder={onBumpOrder}
    />
  );

  if (viewMode === 'columns') {
    return (
      <div className="order-queue order-queue--columns">
        <div className="order-queue__column">
          <h3 className="order-queue__column-header order-queue__column-header--pending">
            {t('kitchen.pending')} ({pending.length})
          </h3>
          <div className="order-queue__cards">
            {pending.map(renderCard)}
          </div>
        </div>
        <div className="order-queue__column">
          <h3 className="order-queue__column-header order-queue__column-header--preparing">
            {t('kitchen.preparing')} ({preparing.length})
          </h3>
          <div className="order-queue__cards">
            {preparing.map(renderCard)}
          </div>
        </div>
        <div className="order-queue__column">
          <h3 className="order-queue__column-header order-queue__column-header--ready">
            {t('kitchen.ready')} ({ready.length})
          </h3>
          <div className="order-queue__cards">
            {ready.map(renderCard)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-queue order-queue--grid">
      {orders.map(renderCard)}
    </div>
  );
};

export default OrderQueue;
